import './index.external.css';

var styles = {"notificationBlock":"notificationBlock-3UFfp","iconBlock":"iconBlock-3UFfp","successNotification":"successNotification-3UFfp","errorNotification":"errorNotification-3UFfp","warningNotification":"warningNotification-3UFfp","infoNotification":"infoNotification-3UFfp","messageNotification":"messageNotification-3UFfp"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
